import * as HB from "handlebars";
import { Helpers } from "@enertech-ch/eapp-document-renderer";
import DocumentImage from "@/store/utils/services/documentImageService.js";

export default class {
  /** @type {HB} */
  handlebars = undefined;
  /** @type {string} */
  clearanceToken = undefined;

  async render(template, context, options) {
    this.prepareRender(options);
    const compiled = this.handlebars.compile(template);
    return await this.postProcessOutput(compiled(context));
  }

  constructor() {
    this.handlebars = new HB.create();
    this.registerStaticHelpers();
  }

  prepareRender(options) {
    this.registerVariableHelpers(
      options.locale ?? "en-US",
      options.timezone ?? "UTC",
      options.localization ?? {}
    );
  }

  async postProcessOutput(output) {
    return await this.processPlaceholders(output);
  }

  registerStaticHelpers() {
    this.handlebars.registerHelper("calculate", Helpers.Calculate.make());
    this.handlebars.registerHelper("image", Helpers.Image.make());
    this.handlebars.registerHelper("set-variable", Helpers.SetVariable.make());
    this.handlebars.registerHelper("payment-slip", Helpers.PaymentSlip.make());
    this.handlebars.registerHelper("match", Helpers.Match.make());
    this.handlebars.registerHelper(
      "electronic-invoice",
      Helpers.ElectronicInvoice.make()
    );

    this.handlebars.registerHelper("input", Helpers.Input.makeWysiwyg());
    this.handlebars.registerHelper("textarea", Helpers.TextArea.makeWysiwyg());
  }

  registerVariableHelpers(locale, timezone, localization) {
    this.handlebars.registerHelper("number", Helpers.Number.make(locale));
    this.handlebars.registerHelper(
      "datetime",
      Helpers.DateTime.make(locale, timezone)
    );
    this.handlebars.registerHelper(
      "translate",
      Helpers.Translate.make(new Map(Object.entries(localization)))
    );
  }

  async processPlaceholders(rendered) {
    await this.getClearance();
    return rendered.replace(
      /<!%%(?<identifier>[^\s]+)\s*(?<attributes>.*?)(\s*%%!>)/gms,
      (fullMatch, identifier, attributes) => {
        switch (identifier) {
          case "image":
            return this.replaceImagePlaceholder(
              this.splitPlaceholderAttributes(attributes)
            );
          case "payment-slip":
            return this.replacePaymentSlipPlaceholder(
              this.splitPlaceholderAttributes(attributes)
            );
          default:
            return fullMatch;
        }
      }
    );
  }

  splitPlaceholderAttributes(string) {
    let attributes = {};
    string.replace(
      /\b(?<key>[^=\s]*)\s*=\s*(["'])(?<value>(?:\\.|(?!\2).)*)\2/gm,
      function(fullMatch, key, quoteChar, value) {
        //quoteChar is used only in the regexp
        attributes[key] = value;
      }
    );
    return attributes;
  }

  replaceImagePlaceholder(attributes) {
    const clearanceParameter = this.clearanceToken
      ? `?clearance=${this.clearanceToken}`
      : "";
    let attributesString = ``;
    for (let [key, value] of Object.entries(attributes)) {
      attributesString +=
        key === "reference"
          ? `src="${DocumentImage.getImageFileUrl(
              attributes.reference
            )}${clearanceParameter}" `
          : `${key}="${value}" `;
    }

    return `<img ${attributesString}>`;
  }

  replacePaymentSlipPlaceholder() {
    const path = process.env.VUE_APP_PUBLIC_PATH || "..";
    return `<img src="${path}/img/QrBillWireGrid.svg">`;
  }

  async getClearance() {
    this.clearanceToken = await DocumentImage.clearance();
  }
}
